import NoticesAnalysisContent from "components/notice_analysis/NoticeAnalysisContent";
import { TrackingProvider } from "lib/tracking";

export function NoticesAnalysisPage() {
  return (
    <TrackingProvider data={{ "Page source": "Market Analysis" }}>
      <NoticesAnalysisContent />
    </TrackingProvider>
  );
}
